import { FunctionalComponent, h } from 'preact';

import { i18nTranslate } from 'common/helper/i18n/translate';
import { TextTrimControlsTemplatePropsInterface } from 'common/module/text-trim/controls/template-props.interface';

export const TextTrimControlsTemplate: FunctionalComponent<TextTrimControlsTemplatePropsInterface> = (props) =>
  props.isVisible ? (
    <div>
      <span className='link link--small' onClick={(e) => props.onClickLink(e, !props.isExpanded)}>
        {props.isExpanded ? i18nTranslate('Read less') : i18nTranslate('Read more')}
      </span>
    </div>
  ) : null;
